import React, { Component } from "react";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
export class RegistrationFace extends Component {
  loadRegistrationFace() {
    window.ConfiaApp.onRegistrationFaceSuccess(this.props.onSuccess);
    window.ConfiaApp.onRegistrationFaceError(this.props.onError);
    window.ConfiaApp.loadRegistrationFace(this.props.externalDatabaseRefID, this.props.identifier, Cookies.get("XSRF-TOKEN"), this.props.frontUuid);
  }

  render() {
    return <div>{this.loadRegistrationFace()}</div>;
  }
}

RegistrationFace.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  externalDatabaseRefID: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  frontUuid: PropTypes.number.isRequired,
};

export default RegistrationFace;
